import FrontBusiness from "@/business/FrontBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import Http from "@/commons/Http";
import moment from "moment";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import { parseIndicadores } from "@/business/indicadores/IndicadorUtils";
import Utils from "@/commons/Utils";
import DominioBusiness from "@/business/protocolo/DominioBusiness";

const path = 'api/protocolo';
const pathV2 = 'api/v2/ato';

const tratarAto = (a) => {
  a.tipoServico = typeof a.tipoServico === 'string' ? JSON.parse(a.tipoServico || false) : a.tipoServico;
  if (a.tipoServico?.opcoes && typeof a.tipoServico?.opcoes === 'string') {
    a.tipoServico.opcoes = JSON.parse(a.tipoServico.opcoes || false)
  }
  a.dto = typeof a.dto === 'string' ? JSON.parse(a.dto || false) || {} : a.dto || {};
  a.doi = typeof a.doi === 'string' ? JSON.parse(a.doi || false) || {} : a.doi || {};
  a.ressarcimento = typeof a.ressarcimento === 'string' ? JSON.parse(a.ressarcimento || false) || {} : a.ressarcimento || {};

  a.envolvidos = typeof a?.envolvidos === 'string' ? JSON.parse(a?.envolvidos || false) || [] : a?.envolvidos;
  (a.envolvidos || []).forEach(envolvido => {
    envolvido.exigencias = typeof envolvido?.exigencias === 'string' ? JSON.parse(envolvido?.exigencias || false) : envolvido?.exigencias;
    envolvido.indices = typeof envolvido?.indices === 'string' ? JSON.parse(envolvido?.indices || false) : envolvido?.indices;
    envolvido.representantes = typeof envolvido?.representantes === 'string' ? JSON.parse(envolvido?.representantes || false) : envolvido?.representantes;
    envolvido.socios = typeof envolvido?.socios === 'string' ? JSON.parse(envolvido?.socios || false) : envolvido?.socios;
  });
  a.custas = typeof a?.custas === 'string' ? JSON.parse(a?.custas || false) : a?.custas;
  a.indices = typeof a?.indices === 'string' ? JSON.parse(a?.indices || false) : a?.indices;
  a.exigencias = typeof a?.exigencias === 'string' ? JSON.parse(a?.exigencias || false) : a?.exigencias;

  parseIndicadores(a);
  return a;

};

export default {

  descricaoVencimentoRestricao(vencimento) {
    const labelVencimento = vencimento && Object.keys(vencimento).length > 0 && vencimento.constructor !== Object ? ` com vencimento no dia ${moment(vencimento).format('DD/MM/YYYY')}` : '';
    return labelVencimento;
  },

  descricaoAtoRestricao(restricao) {
    return restricao.descricao != null ? restricao.descricao : restricao.codigo + ' - ' + restricao.natureza;
  },

  descricaoAtoRestricaoCompleta(restricao, ficha) {
    let codigo = this.getCodigo(restricao, ficha, restricao?.tipoAto)
    return codigo + " - " + (restricao.titulo || restricao.tipoServico || '') + this.descricaoVencimentoRestricao(restricao.vencimento);
  },

  gerarAtoPadrao(servico, prenotacao = 'NORMAL') {
    return {
      envolvidos: [],
      tipoServico: { id: servico },
      dto: {
        doi: {},
        indicador: {},
        camposAdicionais: {},
        valoresBaseCalculo: {},
        origens: [],
      },
      tipoRegistro: prenotacao
    }
  },

  async listarAtos(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/atos`).then(l => l.map(tratarAto));
  },

  async listarIdsAtos(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/listar-ids`);
  },

  async listarAtosProtocolo(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/atos-protocolo`).then(l => l.map(tratarAto));
  },

  async possuiFichaIncompletaOuSemEfeito(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/status-ficha-incompleta`);
  },

  async possuiGestaoManualTabelionato(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/possui-gestao-manual-tabelionato`);
  },

  async restricoesSemRegistrar(protocolo, atoId, indicador) {
    if (!atoId && indicador) return Http.get(`${path}/${protocolo}/ato/atos-restricao/null/${indicador}`);
    return Http.get(`${path}/${protocolo}/ato/atos-restricao/${atoId}`);
  },

  async restricoesSemRegistrarRegistroAuxiliar(protocolo, atoId, registroAuxiliar) {
    if (!atoId && registroAuxiliar) return Http.get(`${path}/${protocolo}/ato/atos-restricao/registroAuxiliar/null/${registroAuxiliar}`);
    return Http.get(`${path}/${protocolo}/ato/atos-restricao/registroAuxiliar/${atoId}`);
  },

  async listarPorFicha(protocolo, livro, id, simplificado) {

    if (!['MATRICULA', 'TRANSCRICAO', 'REGISTRO_AUXILIAR', 'INDICADOR-REAL', 'REGISTRO-AUXILIAR'].includes(livro.toUpperCase())) {
      livro = 'indicador';
    }

    return Http.get(`${path}/${protocolo}/ato/atos/${livro}/${id}${simplificado ? '/simplificado' : ''}`)
      .then(l => l.map(tratarAto));
  },

  async getItensPorId(ids) {
    return await Http.post(`${path}/0/ato/ids`, ids).then(l => l.map(tratarAto));
  },

  async getItensPorIdSimplificado(ids) {
    return await Http.post(`${path}/0/ato/ids/simplificado`, ids).then(l => l.map(tratarAto));
  },

  async getRestricoesPorId(ato, ids) {
    return await Http.post(`${path}/0/ato/${ato}/restricoes`, ids);
  },

  async getById(protocolo, id) {
    if (!Utils.testUUID(id)) {
      return Promise.reject();
    }
    return Http.get(`${path}/${protocolo}/ato/${id}`).then(a => {
      // Ato do Livro 3 (RJ) carrega indicadorRealVinculado como VÍNCULO: a ficha do ato continua sendo o registro auxiliar.
      a.ficha = a.registroAuxiliar || a.indicadorReal || a.indicador;
      if (a.indicadorRealVinculado && a.livro === 'REGISTRO_AUXILIAR') {
        a.ficha = a.registroAuxiliar;
      }
      return a;
    }).then(tratarAto);
  },

  async getEnvolvidos(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/envolvidos`);
  },

  async getEnvolvidosConjugesProtocolo(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/envolvidos-conjuges`);
  },

  async delete(protocolo, id) {
    return Http.delete(`${path}/${protocolo}/ato/${id}`);
  },

  async calcularCustoProtocolo(protocolo) {
    return Http.post(`${path}/${protocolo}/ato/calcular-custo-protocolo`);
  },

  async save(dto, protocolo, id = '') {
    return Http.post(`${path}/${protocolo}/ato/${id}`, dto);
  },

  async verificarEnvolvidosAtos(dto, protocolo, id = '') {
    return Http.post(`${path}/${protocolo}/ato/${id}/verificar-envolvidos-atos`, dto);
  },

  async ajustarEnvolvidosAtos(dto, protocolo, id = '') {
    return Http.post(`${path}/${protocolo}/ato/${id}/ajustar-envolvidos-atos`, dto);
  },

  async salvarIndices(protocolo, id = '', dto) {
    return Http.post(`${path}/${protocolo}/ato/${id}/indices`, dto);
  },

  async imprimir(id, impresso) {
    return Http.post(`${path}/0/ato/${id}/impressao/${impresso}`);
  },

  async marcarAtosImpressos(livro, id, impresso) {
    return Http.post(`${path}/0/ato/impressao/${livro}/${id}/${impresso}`);
  },

  async marcarImpressosLote(livro, impresso, dto) {
    return Http.post(`${path}/0/ato/impressao-lote/${livro}/${impresso}`, dto);
  },

  async inserirLote(protocolo, dto) {
    return Http.post(`${path}/${protocolo}/ato/lote`, dto);
  },

  async lavrarAverbacao(protocoloId) {
    return Http.post(`${path}/${protocoloId}/ato/lavrar-averbacao`);
  },

  async inserirLoteArquivo(protocolo, file, dto) {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("dto", JSON.stringify(dto));

    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    return Http.post(`${path}/${protocolo}/ato/lote-arquivo`, formData, config);
  },

  async criarRegistroAuxiliar(protocolo, dto) {
    return Http.post(`${path}/${protocolo}/ato/criar-registro-auxiliar`, dto);
  },

  async ordenarAtos(protocolo, atos) {
    return Http.post(`${path}/${protocolo}/ato/ordenar`, atos);
  },

  async validar(id, dto) {
    return Http.post(`${path}/0/ato/${id}/validar`, dto);
  },

  // Remove a validação ("destrava") de um ato. dto: {descricao, motivo} — o motivo é opcional na
  // ficha e obrigatório nas telas de análise por IA; quando informado, entra na auditoria do ato.
  async desvalidar(id, dto) {
    return Http.post(`${path}/0/ato/${id}/desvalidar`, dto);
  },

  async validarLote(ids) {
    return Http.post(`${path}/0/ato/validar-lote`, ids);
  },

  async validarRegistrados(id) {
    return Http.post(`${path}/${id}/ato/validar-registrados`);
  },

  // Remove a validação de vários atos. Devolve o resumo {solicitados, removidos, falhas} — cada ato
  // é destravado isoladamente, então parte do lote pode sair e parte ser recusada.
  async desvalidarLote(ids, motivo = null) {
    return Http.post(`${path}/0/ato/desvalidar-lote`, {atos: ids, motivo});
  },

  async recolhimentos() {
    return Http.get(`${path}/0/ato/recolhimentos`);
  },

  async recolhimentosTaxa() {
    return Http.get(`${path}/0/ato/recolhimentos-taxa`);
  },

  // Envia SÓ o que a cópia usa, nunca o envolvido inteiro. O envolvido é um recorte do JSON do ato,
  // e o ato traz `indicadorPessoalVersao.exConjuge` sob @JsonIdentityInfo: a partir da segunda vez
  // que o mesmo ex-cônjuge aparece no documento, ele vem como referência ao id em vez de objeto.
  // Mandar esse recorte de volta quebrava a leitura no backend (UnresolvedForwardReference), porque
  // a referência aponta para um objeto que não existe fora do documento original.
  async copiarCNIB(protocolo, envolvido) {
    return Http.post(`${path}/${protocolo}/ato/copiar-cnib`, {
      indicadorPessoalId: envolvido?.indicadorPessoalId || envolvido?.indicadorPessoalVersao?.indicadorPessoalId,
      consultaCnib: envolvido?.consultaCnib,
      dataConsultaCnib: envolvido?.dataConsultaCnib,
      resultadoConsultaCnib: envolvido?.resultadoConsultaCnib,
    });
  },

  async paginationV2(sort, direction, page, size, filters = {}) {
    return Http.post(`${path}/0/ato/v2/pagination?sort=${sort || 'a.registro'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async copiarAtoOutroProtocolo(protocolo, dto) {
    return Http.post(`${path}/${protocolo}/ato/copiar-ato-outro-protocolo`, dto);
  },

  async editarDataSelagem(dto, protocolo) {
    return Http.post(`${path}/${protocolo}/ato/atualizar-data-selagem`, dto);
  },

  gerarCodigoSimplificado(ordem, inicio, tipo, statusficha = 'PENDENTE') {
    try {

      if (tipo == 'ABERTURA') {
        return 0;
      }

      ordem = (ordem + '.0.').split('.')[1].padEnd(4, '0');
      return parseInt(inicio, 10) + (parseInt(ordem, 10) + (ordem > 1 && statusficha == 'PENDENTE' ? -1 : 0));

    } catch (e) {
      console.error(e);
      return '';
    }

  },

  getCodigo(ato, ficha, tipo, simplificado = false, atos = [], dominio = null) {
    try {

      if (DominioBusiness.isDominioNotas(dominio)) return '';

      ficha = ficha || ato.ficha;
      tipo = tipo || ato.tipo;

      if (tipo == 'ABERTURA') {
        if (simplificado) return '0';
        if (ficha?.livro == 'REGISTRO_AUXILIAR') return 'RA.0';
        const livrosRI = ['MATRICULA', 'TRANSCRICAO', 'TORRENS'];
        return livrosRI.includes(ficha?.livro) ? 'M.0' : 'R.0';
      }

      let codigo;

      if (ato.codigo != null || ato.codigoAto != null || ato.ato != null) {
        codigo = ato.codigo ?? ato.codigoAto ?? ato.ato;
        if (ato.tipo) tipo = ato.tipo;
      } else {

        let ultimo = 0;

        if (ficha?.status != 'PENDENTE' || VueBusiness.getVueRoot()?.config?.indicadorReal?.permitirRegistroPreMatricula) {
          ultimo = ficha?.ultimoAto ?? 0;

          if (atos?.find(ato => (ato.tipo || ato.tipoServico?.opcoes?.tipoAto) === 'ABERTURA' && !ato.registro)) {
            ultimo = 0;
          }
        }

        let naoRegistrados = atos?.filter(a =>
          !a.registro &&
          a.tipoServico &&
          (a.tipo || a.tipoServico?.opcoes?.tipoAto) !== 'ABERTURA'
        ) || [];

        let posicao = naoRegistrados.findIndex(a => a.id === ato.id) + 1;
        if (posicao <= 0) posicao = 1;

        codigo = parseInt(ultimo, 10) + posicao;
      }
      if (simplificado) {
        return codigo;
      }

      let prefix = tipo ? `${tipo == 'REGISTRO' ? 'R' : 'Av'}.` : '';
      return `${prefix}${FrontBusiness.formatarCodigo(parseInt(codigo, 10))}`;

    } catch (e) {
      console.error(e);
      return '';
    }

  },

  nomearAtoVinculavel(ato, atos) {
    const atosNaFicha = atos.filter(x => x.ficha?.id === ato.ficha?.id);
    const codigo = this.getCodigo(ato, ato.ficha, ato.tipo || ato.tipoServico?.opcoes?.tipoAto, false, atosNaFicha);
    const titulo = ato.titulo || ato.tipoServico?.nome;
    const ficha = FrontBusiness.nomearFicha(ato.ficha);
    return `${codigo} - ${titulo} - ${ficha}`;
  },

  formatarValorCusta(ato, protocolo, servico = '') {

    if (ato.isento && !ato.valor || (servico !== 'certidao' && protocolo?.tipoRegistro === 'ISENTO' && !!ato.isento)) {
      if (servico === 'certidao') {
        return 'Isenta';
      } else {
        return 'Isento';
      }
    }

    if (!ato.registro && !ato.valor && (!ato.custas || ato.custas.erro)) {
      return '-';
    }

    return Number(ato.valor).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      style: 'decimal',
      currency: 'BRL'
    });

  },

  camposBaseCalculo() {
    return Object.freeze([
      { id: 'ALIENACAO', nome: 'Negócio/Alienação', possuiAtualizacao: true, label: 'Valor do Negócio/Alienação', key: 'alienacao', dominio: ['PROTOCOLO_RI', 'PROTOCOLO_RTD', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'AVALIACAO', nome: 'Avaliação', possuiAtualizacao: true, label: 'Valor de Avaliação Fiscal', key: 'valorAvaliacao', help: '(ITBI/ITCD)', dominio: ['PROTOCOLO_RI', 'PROTOCOLO_RTD', 'PROTOCOLO_RCPJ', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'DIVIDA', nome: 'Dívida', possuiAtualizacao: true, label: 'Valor da Dívida', key: 'valorDivida', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'IMOVEL', nome: 'Imóvel', possuiAtualizacao: false, label: 'Valor Atribuído ao Imóvel', key: 'valorImovel', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'MERCADO', nome: 'Mercado', possuiAtualizacao: false, label: 'Valor de Mercado', key: 'valorMercado', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'VENAL', nome: 'Venal', possuiAtualizacao: false, label: 'Valor Venal', key: 'valorVenal', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'MEACAO', nome: 'Meação', possuiAtualizacao: false, label: 'Valor de Meação', key: 'valorMeacao', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'LEILAO', nome: 'Leilão', possuiAtualizacao: false, label: 'Valor de Leilão', key: 'valorLeilao', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'RECURSOS_PROPRIOS', nome: 'Recursos Próprios', possuiAtualizacao: false, label: 'Recursos Próprios', key: 'recursosProprios', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'FGTS', nome: 'FGTS', possuiAtualizacao: false, label: 'FGTS', key: 'fgts', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'FGTS_DESCONTO', nome: 'FGTS (Desconto)', possuiAtualizacao: false, label: 'FGTS (Desconto)', key: 'fgtsDesconto', dominio: ['PROTOCOLO_RI', 'ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'ATA_NOTARIAL'] },
      { id: 'VTI', nome: 'Valor Total do Imóvel (VTI)', possuiAtualizacao: false, label: 'Valor Total do Imóvel (VTI)', key: 'vti', dominio: ['PROTOCOLO_RI'] },
      { id: 'VTN', nome: 'Valor da Terra Nua (VTN)', possuiAtualizacao: false, label: 'Valor da Terra Nua (VTN)', key: 'vtn', dominio: ['PROTOCOLO_RI'] },
    ]);
  },

  getEnvolvidosEstrangeiros(envolvidos = []) {
    const envolvidosEstrangeiros = [];
    envolvidos?.forEach(e => {
      if (e.papel === 'ADQUIRENTE' && IndicadorPessoalBusiness.indicadorPessoalIsEstrangeiro(e.indicadorPessoalVersao || e)) {
        envolvidosEstrangeiros.push(e);
      }
    });
    return envolvidosEstrangeiros;
  },

  mostrarCampoLivroEstrangeiro(ato) {
    if (ato?.tipoServico?.opcoes?.inserirLivroEstrangeiro === false && !ato.registro) {
      return false;
    }

    if ((ato?.ficha?.categoria === 'RURAL' && this.getEnvolvidosEstrangeiros(ato.envolvidos).length > 0) || (ato.registro && ato.id && ato.livroEstrangeiro > 0)) {
      return true;
    }

    return false;
  },

  async excluirAtos(atos, verificar = true, registrados = true) {
    let continua = [];
    if (verificar && atos.find(a => a.registro)) continua = await this.verificarAlertasExclusao(atos);
    if (continua.length) return continua;
    if (atos.length) {
      let promises = atos.map(ato => this.delete(0, ato.id)
        .catch(e => {
          FrontBusiness.showError('', `${e?.message}: ${this.getCodigo(ato, null, ato?.tipoServico?.opcoes?.tipoAto)}` || 'Ocorreu um erro ao tentar excluir o ato')
        }));
      return await Promise.all(promises)
    }
  },

  async verificarAlertasExclusao(atos) {
    let continua = [];
    let ids = (atos || []).map(f => f.id);
    let verificacao = await this.verificarAlertasExclusaoAto(ids);
    if (verificacao) continua = await this.confirmarExclusaoAto(atos, verificacao, 'checkbox');
    return continua;
  },

  async confirmarExclusaoAto(atos, title, input = null) {
    let result = await FrontBusiness.showConfirmacao(title, `Esta ação excluirá o${atos.length > 1 ? 's' : ''} ato${atos.length > 1 ? 's' : ''}. Deseja Continuar?`, input, 'Tenho certeza que desejo continuar.', 'Observações: As alterações que ocorreram no imóvel não serão desfeitas, ou seja, se o ato alterou proprietário ou algum dado do imóvel, após excluir o ato, as alterações não serão desfeitas.').then(async r => {
      if (r.value) {
        return await this.excluirAtos(atos, false);
      } else if (r.dismiss === 'cancel') {
        return [false];
      } else {
        return [false];
      }
    }).catch(this.showError);

    return result
  },

  camposObrigatoriosRessarcimento({ obrigatorios, motivoIsencao }) {
    if (VueBusiness.getVueRoot().isEstadoSC && motivoIsencao === 'T_54') {
      const remover = ['tipoProcesso', 'numeroProcesso'];
      return obrigatorios.filter(item => !remover.includes(item));
    }
    return obrigatorios;
  },

  async verificarAlertasExclusaoAto(ids) {
    return await Http.post(`${path}/0/ato/verificar-alertas-exclusao-ato`, ids);
  },

  getValoresCalculadora(protocolo, tipoServico) {
    return Http.get(`${pathV2}/calculadora-divida/${protocolo}/${tipoServico}`);
  },

  atualizarValoresDivida(protocolo, tipoServico, valores) {
    return Http.post(`${pathV2}/calculadora-divida/${protocolo}/${tipoServico}`, valores);
  },

  async salvarTextoLote(protocolo, dto) {
    return await Http.post(`${path}/${protocolo}/ato/texto-lote`, dto);
  },

  async editarTipoServico(protocolo, id, tipoServico) {
    return Http.get(`${path}/${protocolo}/ato/${id}/editar-tipo-servico/${tipoServico}`);
  },


  async tratarAlteracaoAtoDigital(ato, atos) {
    let marcando = !ato.digital;
    let ids = [];
    if (marcando) {
      ids = atos.filter(a => a.codigo > ato.codigo && a.digital !== marcando).map(a => a.id);
    } else {
      ids = atos.filter(a => a.codigo < ato.codigo && a.digital !== marcando).map(a => a.id);
    }
    ids.push(ato.id);
    await this.alterarAtoDigital(ato.protocoloId || '00000000-0000-0000-0000-000000000000', ids, marcando)
      .catch(error => {
        FrontBusiness.showError('', error.message);
      });
  },

  async alterarAtoDigital(protocolo, listaId, status) {
    return await Http.post(`${path}/${protocolo}/ato/alterar-ato-digital/${status}`, listaId);
  },

  async marcarAtoDigital(protocolo, ids) {
    return await Http.post(`${path}/${protocolo}/ato/marcar-ato-digital`, ids);
  },

  async validarAto(protocolo, tipoIndicador, ato, simulacaoCompleta, modo) {
    let dto = { tipoIndicador, simulacaoCompleta, modo };
    return await Http.post(`${path}/${protocolo}/ato/validar-ato/${ato}`, dto);
  },
  getUrlDownloadMinuta(protocoloId, atoId) {
    return `${window.server.API}/${path}/${protocoloId}/ato/${atoId}/minuta/download`;
  },

  async ultimoLivroRegistroAtoIndicador(atoId) {
    return await Http.get(`${path}/null/ato/${atoId}/ultimo-livro-rtdpj`);
  },

  async getSimularControleFolhas(atoId) {
    return await Http.get(`${path}/null/ato/${atoId}/ultimo-livro-rtdpj`);
  },

  async simularLivroRegistroAtoIndicador({livro, folhaInicial, quantidadeFolhas, ladoInicial}) {
    return await Http.get(`${path}/null/ato/simular-livro-rtdpj/${livro}/${folhaInicial}/${quantidadeFolhas}/${ladoInicial}`);
  },

  async getPrimeiroAtoComValor(protocolo) {
    return Http.get(`${path}/${protocolo}/ato/primeiro-com-valor`);
  },

  async atualizarAssinaturaEnvolvido(protocolo, ato, envolvido, dto) {
    return Http.post(`${path}/${protocolo}/ato/${ato}/envolvido/${envolvido}/assinatura`, dto);
  },

  async atualizarAssinaturaRepresentante(protocolo, ato, representanteId, dto) {
    return Http.post(`${path}/${protocolo}/ato/${ato}/representante/${representanteId}/assinatura`, dto);
  },

  async simularLivroFolhaNotas(protocoloId) {
    return Http.get(`${path}/${protocoloId}/ato/simular-livro-folha-notas`);
  },

}
